<template>
  <div class="newfollowup">
    <div :class="isEdit == 1 ? 'content-wrap' : 'content-wrap no-padding-bottom'">
      <div class="staff-wrap">
        <span class="staff-label fs16 title-color">客户名称</span>
        <span class="staffname text-right common-color">{{customerInfo.customerName}}</span>
      </div>
      <div class="ftypeWrap flex border-top">
        <div  class="ftypeTitle flex1 fs16">跟进类型</div>
        <div  class="ftypeSelect text-right flex3">
          <zwySelect placeHolder="请选择跟进类型" @selectListItem="selectType" :contentText="selectFollowupType.text"></zwySelect>
        </div>
      </div>
      <div class="labelTitle fs16">跟进内容</div>
      <div class="followupTex white text-center" >
        <textarea class="talktext" placeholder="输入跟进内容" rows="3" v-model="talktext" :disabled="isEdit == 0" maxlength="500" @blur="talktext ? showPlaceHolder = false : showPlaceHolder = true " @focus="showPlaceHolder = false" >
        </textarea>
      </div>
      <div>
        <div class="labelTitle fs16 border-top" style="margin-top: 0.1rem;">附件<span v-if="isEdit == 1"><span class="task" style="color:#B4BEC7;font-size:0.12rem;">（最多3张图片,每张图片大小不能超过8M）</span></span></div>
        <div class="uploadWrap border-bottom">
          <van-row class="uploadImgRow">
            <van-col class="uploadImgCol" :span="(item.indexOf('.bmp')!=-1 || item.indexOf('.jpg')!=-1 || item.indexOf('.jpeg')!=-1 || item.indexOf('.JPEG')!=-1 || item.indexOf('.png')!=-1 || item.indexOf('.gif')!=-1 || item.indexOf('.tif')!=-1 || item.indexOf('.pcx')!=-1) ? 8 : 24" v-for="(item,index) in fileList" :key="index">
              <img v-if="item.indexOf('.bmp')!=-1 || item.indexOf('.jpg')!=-1 || item.indexOf('.jpeg')!=-1 || item.indexOf('.JPEG')!=-1 || item.indexOf('.png')!=-1 || item.indexOf('.gif')!=-1 || item.indexOf('.tif')!=-1 || item.indexOf('.pcx')!=-1" class="uploadImg" :src="item" @click="preImgClick(item,index)">
              <div class="file-row" v-else-if="wxenv=='public'"><a :href="item" :download="followupInfo.file[index].name">{{followupInfo.file[index].name}}</a></div>
              <div v-if="isEdit == 1" class="imgDeleteBtn" @click="deleteImg(index)">
                <van-icon name="delete" />
              </div>
            </van-col>
            <van-col span="8" v-show="isEdit == 1 && fileList.length < 3">
              <van-uploader :after-read="onRead" accept="image/*">
                <div class="pluss">
                  <span>+&nbsp;添加图片</span>
                </div>
              </van-uploader>
            </van-col>
          </van-row>
        </div>
      </div>
      <div v-if="isEdit == 0" class="staff-wrap contact border-top">
        <span class="staff-label fs16 title-color">跟进人</span>
        <span class="staffname text-right common-color">{{followupInfo.staffName}}</span>
      </div>
      <div v-if="isEdit == 0" class="staff-wrap serviceFollowUpDate">
        <span class="staff-label fs16 title-color">跟进日期</span>
        <span class="staffname text-right common-color">{{followupInfo.talktime}}</span>
      </div>
    </div>
    <div class="save-btnwrap white" v-show="isEdit == 1">
      <span class="primary bold fs16" @click="saveFollowup()">保存</span>
    </div>
    <van-popup v-model="showFollowupList" position="bottom">
      <van-picker v-if="type_options.length>0" show-toolbar title="跟进类型" :columns="type_options" @cancel="showFollowupList = false" @confirm="selectFollowup"/>
      <div v-else class="noData">暂无跟进类型</div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Exif from 'exif-js';
import zwySelect from "@/components/Select.vue";
import wx from "weixin-js-sdk";
import { Toast, ImagePreview, Uploader, Row, Col, Icon, DropdownMenu, DropdownItem, Cell, ActionSheet, Popup, Picker } from "vant";
Vue.use(Toast)
.use(ImagePreview)
.use(Uploader)
.use(Row)
.use(Col)
.use(Icon)
.use(DropdownMenu)
.use(DropdownItem)
.use(Cell)
.use(ActionSheet)
.use(Popup)
.use(Picker);
export default {
  name: "newfollowup",
  components: {
    zwySelect
  },
  data() {
    return {
      staffName: Object.keys(this.$store.state.userInfo).length>0 && this.$store.state.userInfo.staff.name || '',
      accCompanyId: this.$store.state.acctCompanyInfo.accCompanyId,
      env:this.$store.state.acctCompanyInfo.env,
      talktext: "",
      companyId: this.$route.query.companyId,
      type_options: [],
      type_value: 0,
      fileList: [],
      fileIdList: [],
      isEdit: this.$route.query.isEdit,
      customerInfo: this.$route.query.customerInfo,
      followupInfo: this.$route.params,
      showFollowupList: false,
      showPlaceHolder: true,
      selectFollowupType: {},
      files: {
        name: "",
        type: ""
      },
      headerImage: null,
      picValue: null,
      imagePreview: null,
      uploadToast:{},
      wxenv: ""
    };
  },
  methods: {
    saveFollowup() {
      this.$root.$emit('log-record',"60010112");
      if (!this.talktext.trim()) {
        Toast("请输入详细跟进情况");
        return false;
      }
      let defaultParams = {
        talktext: this.talktext,
        fileIdList: this.fileIdList.join(","),
        followType: this.type_value
      };
      let url = "/fc/small/program/followup/small?companyId=" + this.companyId;
      this.$http.post(url, defaultParams).then(result => {
        if (result.data.code === 200) {
          Toast("保存成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }
      });
    },
    getFolllwType() {
      const url =
        "/fc/small/program/followType/small?companyId=" + this.companyId;
      this.$http
        .post(url)
        .then(res => {
          console.log(res, "/fc/small/program/followType/small");
          if (res.data.code == 200) {
            // console.log("获取跟进类型成功！");
            this.type_options =
              res.data.data.items.length > 0 &&
              res.data.data.items.map(c => {
                return { text: c.name, value: c.itemId };
              });
            // this.type_value = res.data.data.items.length > 0 && res.data.data.items[0].itemId;
            if (this.isEdit == 0) {
              this.type_options.forEach(option => {
                if (this.followupInfo.followType == option.value) {
                  this.selectFollowupType = option
                  this.handleTypeChange(option.itemId)
                }
              })
            }
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    handleTypeChange(val) {
      this.type_value = val;
    },
    preImgClick(img, index) {
      const imgList = [];
      imgList.push(img);
      this.imagePreview = ImagePreview({
        images: this.fileList,
        startPosition: index
      });
    },
    deleteImg(index) {
      this.$http
        .get(
          "/fc/small/program/deleteimage?accCompanyId=" +
            this.accCompanyId +
            "&fileId=" +
            this.fileIdList[index]
        )
        .then(res => {
          console.log(res, "/fc/small/program/deleteimage");
          if (res.data.code == 200) {
            Toast("操作成功！");
            this.fileList.splice(index, 1);
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
        });
    },
    selectType () {
      if (this.isEdit == 0) {
        return 
      }
      this.showFollowupList = true
    },
    selectFollowup (value) {
      this.selectFollowupType = value
      this.handleTypeChange(this.selectFollowupType.value)
      this.showFollowupList = false
    },

    // 组件方法 获取 流
    async onRead(file) {
      const isLt2M = file.file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        Toast('图片大小不能超过8MB!')
        return false;
      }
      this.uploadToast = Toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '图片上传中，请稍候...'
      });
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.picValue = file.file; // 文件流
      this.imgPreview(this.picValue);
    },
    // 处理图片
    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          // console.log(this.result);
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否小于200K,是就直接上传，反之压缩图片
          if (this.result.length <= 200 * 1024) {
            self.headerImage = this.result;
            self.postImg();
          } else {
            img.onload = function() {
              let data = self.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      });
    },
    //这里写接口
    async postImg() {
      let file = this.dataURLtoFile(this.headerImage);
      //由于上传经过Nginx路由会报错，所以上传接口强制转成首页接口所返回的env的环境的接口
      const aurl = "https://" + this.env + ".kdzwy.com/fc/small/program/uploadimage";
      console.log(aurl,"aurlaurlaurl")
      let formData = new FormData();
      formData.append("file", file);
      formData.append("accCompanyId", this.accCompanyId);
      formData.append("id", this.companyId);
      formData.append("type", 2);
      try {
        const instance = axios.create({
        withCredentials: true
      });
      instance.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8';
      instance
        .post(
          aurl,
          formData
        )
        .then(res => {
          if (res.data.code == 200) {
            this.fileList.push(decodeURIComponent(res.data.data.filePath));
            this.fileIdList.push(res.data.data.fileId);
            Toast.success('上传成功');
            this.uploadToast.duration = 2;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
          Toast.clear();
        });
      } catch (e) {
        console.log(e);
      }
    },
    getEnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            this.wxenv = "miniprogram";
          } else {
            this.wxenv = "public";
          }
        });
      } else {
        this.wxenv = "public";
      }
    },
  },
  mounted: function() {
    if (this.isEdit == 0) {
      this.talktext = this.followupInfo.talktext
      if (this.followupInfo.file.length > 0) {
        this.followupInfo.file.forEach(file => {
          this.fileList.push(decodeURIComponent(file.filePath))
          this.fileIdList.push(file.fileId)
        });
      }
    }
    this.getFolllwType();
    this.getEnv()
  },
  beforeDestroy(){
    if (this.imagePreview) {
      this.imagePreview.close()
    }
    Toast.clear();
    window.sessionStorage.setItem('tabIndex', 1)
    console.log('2345')
  }
};
</script>

<style type="text/css" scoped>
.ftypeWrap {
  line-height: 0.46rem;
  background: #ffffff;
  padding: 0 0.24rem 0 0.16rem;
  border-bottom: 1px solid #E6EBF0;
  position: relative;
}
.ftypeWrap .van-dropdown-menu {
  height: auto;
  background-color: transparent;
}
.ftypeWrap .van-dropdown-menu .van-dropdown-menu__item {
  justify-content: start;
}
.ftypeWrap
  .van-dropdown-menu
  .van-dropdown-menu__item
  .van-dropdown-menu__title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 2rem;
  padding-right: 0.24rem;
}
.ftypeWrap
  .van-dropdown-menu
  .van-dropdown-menu__item
  .van-dropdown-menu__title::after {
  right: 0;
  top: 0.2rem;
}
.ftypeWrap .van-dropdown-item .van-popup .van-cell .van-cell__title {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
}
.newfollowup {
  height: 100%;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
}
.newfollowup .content-wrap {
  flex: 1;
}
.content-wrap {
  position: absolute;
  width: 100%;
  padding-bottom: 0.6rem;
}
.staff-wrap {
  display: flex;
  margin-bottom: 0.08rem;;
  height: 0.46rem;
  background: white;
  line-height: 0.46rem;
  padding: 0 0.16rem;
  border-bottom: 1px solid #E6EBF0;
}
.contact.staff-wrap{
  margin-bottom: 0;
  margin-top: 0.1rem;
}
.serviceFollowUpDate.staff-wrap{
  margin-bottom: 0;
}
.staff-label {
  width: 90px;
}
.staffname {
  flex: 1;
  text-align: right;
}
.talktext {
  box-sizing: border-box;
  height: 1.66rem;
  margin: 0 0.16rem;
  margin-bottom: 0.16rem;
  width: calc(100% - 0.32rem);
  border-radius: 4px;
  resize: none;
  line-height: 30px;
  padding: 0.04rem 0.12rem;
  color: #516374;
  outline: 0;
  border: 0;
  background: #F9FBFC;
  /* border: 1px solid #B4BEC7; */
}

.file-wrap {
  display: flex;
  margin-top: 12px;
}
.file-wrap span {
  display: flex;
  position: relative;
}
.file-wrap .icon-circle-close {
  position: absolute;
  top: 0px;
  right: 10px;
  color: gray;
  font-size: 18px;
}
.file-wrap img {
  width: 60px;
  height: 60px;
  margin-right: 10px;
}

.save-btnwrap {
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
}
.save-btnwrap span {
  display: inline-block;
  text-align: center;
  width: 100%;
  line-height: 0.5rem;
  border-top: 1px solid #E6EBF0;
}
.labelTitle {
  line-height: 0.46rem;
  padding: 0 0.16rem;
  background: #ffffff;
}
.followupTex {
  border-bottom: 1px solid #E6EBF0;
}
.followup-content {
  position: relative;
  top: -1.1rem;
}
textarea::-webkit-input-placeholder {
  color: #b4bec7;
  text-align: center;
  line-height: 1.60rem;
}
.file-row{
  font-size: 0.14rem;
  text-align: left;
  padding: 0.04rem 0.16rem;
}
.file-row a{
  color: #1fadf6;
}
</style>
<style lang="stylus" scoped>
.pluss {
  width: 1.04rem;
  height: 1.04rem;
  border: 1px solid #F0F2F2;
  line-height: 1.04rem;
  text-align: center;
  color: #B4BEC7;
  background: #F9FBFC;
}

.uploadWrap {
  background: #ffffff;

  .uploadImgRow {
    text-align: center;
    padding: 0.08rem 0;
    padding-bottom: 0.2rem;
    .uploadImgCol {
      font-size 0
      position relative
      .imgDeleteBtn{
        font-size 0.2rem
        position: absolute;
        bottom: 0;
        right: 0.1rem;
        padding 0.02rem
        background rgba(0,0,0,0.1);
        color #ffffff
        line-height: 0.2;
      }
    }

    .uploadImg {
      width: 1.04rem;
      height 1.04rem
    }
  }
}
.content-wrap.no-padding-bottom{
 padding-bottom:0;
}
.noData{
  text-align: center;
  padding: 0.24rem 0;
  color: #8896a4;
}
</style>

